import useTracker from '@hooks/useTracker';
import {
  KYC_FIRST_PAGE_SUBMIT,
  KYC_SECOND_PAGE_SUBMIT,
  KYC_THIRD_PAGE_SUBMIT,
  KYC_FOURTH_PAGE_SUBMIT,
  KYC_FIFTH_PAGE_SUBMIT,
  KYC_SIXTH_PAGE_SUBMIT_BCA,
  KYC_SIXTH_PAGE_SUBMIT_PERMATA,
} from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventKycFirstPage = (props) => {
    trackEvent(KYC_FIRST_PAGE_SUBMIT, props);
  };

  const eventKycSecondPage = () => {
    trackEvent(KYC_SECOND_PAGE_SUBMIT);
  };

  const eventKycThirdPage = () => {
    trackEvent(KYC_THIRD_PAGE_SUBMIT);
  };

  const eventKycFourthPage = (props) => {
    trackEvent(KYC_FOURTH_PAGE_SUBMIT, props);
  };

  const eventKycFifthPage = (props) => {
    trackEvent(KYC_FIFTH_PAGE_SUBMIT, props);
  };

  const eventKycSixthPageBca = (props) => {
    trackEvent(KYC_SIXTH_PAGE_SUBMIT_BCA, props);
  };

  const eventKycSixthPagePermata = (props) => {
    trackEvent(KYC_SIXTH_PAGE_SUBMIT_PERMATA, props);
  };

  return {
    eventKycFirstPage,
    eventKycSecondPage,
    eventKycThirdPage,
    eventKycFourthPage,
    eventKycFifthPage,
    eventKycSixthPageBca,
    eventKycSixthPagePermata,
  };
};

export default useEventTracker;
